import { AMPS2 } from 'utils/constants'

export const POWER_NET_LEVELS = [7, 5, 3, 0]

export const POWER_NET_LEVELS_MAPPING = Object.freeze({
  FIRST_GROUP: 7,
  SECOND_GROUP: 5,
  THIRD_GROUP: 3,
  LAST_GROUP: 0,
})

export const DEFAULT_POWER_NET_LEVEL = 7
export const DEFAULT_CURRENT = AMPS2

export const DEFAULT_KEEP_AWAKE = false

export const DEFAULT_RESET_ATTEMPTS = 0
export const DEFAULT_RESET_DELAY = 0

export const KEEP_AWAKE_MAPPING = Object.freeze({
  ON: true,
  OFF: false,
})

export const PWM_MODES = [1, 2, 3]
export const PWM_MODES_MAPPING = Object.freeze({
  FIXED_DUTY_CYCLE_AND_FREQUENCY: 1,
  VARIABLE_DUTY_CYCLE: 2,
  VARIABLE_FREQUENCY: 3,
})

export const BATTERY_VOLTAGE_RANGE = {
  LOW_OFF: 12.1,
  LOW: 12.2,
  HIGH_OFF: 12.3,
  HIGH: 12.4,
}

export const POWER_NET_LEVEL_SIGNAL_URIS = {
  BATTERY_VOLTAGE: '/signals/SIG00122',
  ENGINE_SPEED: '/signals/SIG00096',
  IGNITION_STATUS: '/signals/SIG00069',
}

export const POWER_NET_LEVEL_SIMULATION_DEFAULTS = {
  BATTERY_VOLTAGE: 12.4,
  ENGINE_SPEED: 0,
  IGNITION_STATUS: 0,
}

export const IGNITION_TRANSLATIONS = {
  OFF: 'off',
  ACCESSORY: 'accessory',
  RUN: 'run',
  CRANK: 'crank',
}

export const IGNITION_STATES = {
  OFF: 0,
  ACCESSORY: 1,
  RUN: 2,
  CRANK: 3,
}
